module.exports = __webpack_public_path__ + "static/media/cave.9ba3ec37.svg";